module.exports = __webpack_public_path__ + "img/43268E36B6E04671.67d015ff.png";